import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@shared/components/lib-ng/lib-ng-bootstrap/modal/modal-ref';
import { ToastrService } from '@shared/components/lib-ngx/ngx-toastr/toastr/toastr.service';
import {
  ImageCroppedEvent,
  ImageCropperComponent,
  LoadedImage,
} from '@shared/components/lib-ngx/public-api';
import { DragDropImageService } from './drag-drop-image.service';
import { ZaaFileV2LoaderDirective } from '@shared/directives/zaa-load-file-v2/zaa-load-file-v2.directive';
import { IFileV2 } from '@shared/directives/zaa-load-file-v2/file-v2.interface';
@Component({
  standalone: true,
  imports: [CommonModule, ImageCropperComponent, ZaaFileV2LoaderDirective],
  providers: [DragDropImageService],
  selector: 'app-drag-drop-image',
  templateUrl: './drag-drop-image.component.html',
  styleUrls: ['./drag-drop-image.component.scss'],
})
export class DragDropImageComponent implements OnInit {
  @Input() fileV2!: IFileV2;

  protected activeModal = inject(NgbActiveModal);
  protected toastService = inject(ToastrService);

  service = inject(DragDropImageService);

  isSaving = false;

  isProcessingImage: boolean = false;
  showErrorLoadImaged: boolean = false;

  imageChangedEvent: Event | null = null;
  // croppedBlob: Blob | null = null;
  croppedImage: SafeUrl = '';
  croppedImageBlob: Blob | null = null;
  isOnInit: boolean = true;
  // imageUrlOld: any;
  // _imageCropped: any;

  constructor(private sanitizer: DomSanitizer) { }
  ngOnInit(): void {
    // this.service.loadImage(this.fileV2).subscribe({
    //   next: (value) => {
    //     if (value) {
    //       this.imageUrl = value[0].url;
    //       this.imageUrlOld = this.imageUrl;
    //     }
    //   },
    // });
    this.croppedImage = "assets/img/no-image-available.jpg";
  }

  fileChangeEvent(event: Event): void {
    this.showErrorLoadImaged = false;
    if (this.imageChangedEvent && !(event.target as any)?.files.length) return;
    this.isOnInit = false;
    this.isProcessingImage = true;
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    if (event.objectUrl) {
      this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
      this.isProcessingImage = false;
    }
    if (event.blob) {
      this.croppedImageBlob = event.blob;
    }
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
    this.toastService.warning('Vui lòng xem lại các chú ý đã yêu cầu.', 'Đã có lỗi khi hiển thị ảnh');
    this.showErrorLoadImaged = true;
    this.isProcessingImage = false;
  }

  onClose = (): void => {
    this.activeModal.close();
    // this.router.navigateByUrl(this.callbackURL);
  };

  onSuccess(url: string) {
    this.activeModal.close(url);
  }

  onSubmit() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    if (!this.croppedImageBlob) {
      this.toastService.warning('Không tìm thấy hình ảnh nào đê cập nhật', 'Cảnh báo');
      this.isSaving = false;
      return;
    }

    this.service.upload(this.croppedImageBlob).subscribe({
      next: (value: any) => {
        this.isSaving = false;
        this.toastService.success('Upload ảnh thành công', 'Thành công');
        this.activeModal.close(value);
      },
      error: (err) => {
        console.error(err);
        this.isSaving = false;
        this.toastService.error(
          'Có lỗi xảy ra trong quá trình upload ảnh',
          'Lỗi hệ thống'
        );
      },
    });
  }

  onRemoveAvatar(): void {
    // this._imageCropped = this.imageUrlOld;
    // this.croppedBlob = null;
    // this.imageChangedEvent = null;
    // this.imageUrl = null;
    // from(
    //   Swal.fire({
    //     title: 'Xác nhận xóa ảnh đại diện',
    //     text: 'Bạn có chắc muốn xóa ảnh đại diện của bạn? Sau khi xóa bạn sẽ dùng ảnh đại hiện mạc định',
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonText: 'Xóa',
    //     cancelButtonText: 'Hủy',
    //     reverseButtons: true,
    //   })
    // ).subscribe({
    //   next: (value) => {
    //     if (value.isConfirmed) {
    //       this.getImageFile();
    //     }
    //   },
    // });
  }
}
